import { Severity } from '~/common/types/pcfra';

export const severityRiskValueMap: Record<Severity, number> = {
  Low: 0.5,
  Medium: 1.5,
  High: 2.5,
};

export const calculateRiskLevel = (fireLikelihood: Severity, harmPotential: Severity) =>
  severityRiskValueMap[fireLikelihood] + severityRiskValueMap[harmPotential];
